import { onTurboLoad, onTurboBeforeCache, initializePageScrollPositionAndActiveTabsSaver } from '../turboHelper';
import "../../styles/site.scss";
import "../../styles/icomoon.scss";
import * as Dropzone from 'dropzone';
import { initializeMinCollectionLengthValidation, initializeExpressiveAnnotationsCustomTypeHandling } from "../Validations/validationHelpers";
import { initializeToggleSectionVisibility } from '../toggleSectionVisibility';
import { initializeInputFileClearing } from '../inputFileClearing';
import { initializeDateTimePickers } from '../datetimePickersInit';
import { initializeTranslations } from '../translate';
import { resetSelectizeToCorrectlyMeasureTextWidth } from '../selectizeHelper';
import { fixChromeWrappingTextInSpanWhenDeletingLineBreak, initializeSummerNoteIgnoredInValidation } from '../summernoteHelper';
import { initializeTooltips } from '../tooltips';
//import { initializeUserback } from '../userback';
import { initializeStorage } from '../storageHelper';
import { getApplicationContext } from '../applicationContext';
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import * as smartlookClient from 'smartlook-client';
import { StimulusControllers } from '../_generated/StimulusControllers';
import { initializeHubSpotChat } from '../hubSpotChat';

import { Application } from "@hotwired/stimulus";
import AudioPlayerController from "../../Components/AudioPlayer/AudioPlayerController";
import AudioEditorController from "../../Components/AudioEditor/AudioEditorController";
import CollapsibleSectionController from "../../Components/CollapsibleSection/CollapsibleSectionController";
import CompaniesCreateOrEditController from "../Companies/CreateOrEditController";
import RegisterCompanyController from "../../Features/Account/Pages/RegisterCompanyController";
import DestinationsAddNewDestinationController from "../Destinations/AddNewDestinationController";
import DestinationsCloningController from "../Destinations/CloningController";
import DestinationsCreateOrEditController from "../Destinations/CreateOrEditController";
import DestinationsDetailBasicInformationController from "../Destinations/DetailBasicInformationController";
import DestinationsDetailController from "../Destinations/DetailController";
import DestinationsIndexController from "../Destinations/IndexController";
import DestinationsAddNewDestinationMapController from '../../Features/Destinations/Components/AddNewDestinationMap/AddNewDestinationMapController';
import DestinationsClonedDestinationsListController from '../../Features/Destinations/Components/ClonedDestinationsList/ClonedDestinationsListController';
import DestinationsProgressBarStepController from "../../Features/Destinations/Components/ProgressBarStep/ProgressBarStepController";
import DestinationsMagicallyOpenClonedDestinationController from "../../Features/Destinations/Pages/MagicallyOpenClonedDestination/MagicallyOpenClonedDestinationController";
import DestinationsValidationCheckController from "../Destinations/ValidationCheckController";
import ImageEditorController from "../../Components/ImageEditor/ImageEditorController";
import MapController from "../../Components/Map/MapController";
import TourMapController from "../../Components/TourMap/TourMapController";
import PhonemesCreateOrEditController from "../../Features/Phonemes/Pages/CreateOrEdit/CreateOrEditController";
import PhonemesDeleteController from "../../Features/Phonemes/Pages/Delete/DeleteController";
import PoisCreateController from "../Pois/CreateController";
import PoisCreateOrEditController from "../Pois/CreateOrEditController";
import PoisDetailOldController from "../Pois/DetailOldController";
import PoisDetailController from "../../Features/Pois/Pages/Detail/DetailController";
import PoisCreateNewPoiFromMapController from "../../Features/Pois/Pages/CreateNewPoiFromMap/CreateNewPoiFromMapController";
import PoisDetailAdditionalInformationController from "../../Features/Pois/Pages/Detail/Frames/AdditionalInformation/AdditionalInformationController";
import TranslationController from "../../Features/Shared/Components/Translation/TranslationController";
import PoisDetailBasicInformationController from "../../Features/Pois/Pages/Detail/Frames/BasicInformation/BasicInformationController";
import PoisDetailAiGeneratedContentController from "../../Features/Pois/Pages/Detail/AiGeneratedContentController";
import PoisDetailCommonInformationController from "../../Features/Pois/Pages/Detail/Frames/CommonInformation/CommonInformationController";
import PoisDetailGeographicalInformationController from "../../Features/Pois/Pages/Detail/Frames/GeographicalInformation/GeographicalInformationController";
import SectionItemController from "../../Components/SectionItem/SectionItemController";
import ToursCreateController from "../Tours/CreateController";
import ToursEditController from "../Tours/EditController";
import ToursDetailAdditionalInformationController from "../Tours/DetailAdditionalInformationController";
import ToursDetailBasicInformationController from "../Tours/DetailBasicInformationController";
import ToursDetailController from "../Tours/DetailController";
import ToursDetailIndoorTourGeographicalInformationController from "../../Features/Tours/Pages/Detail/Frames/IndoorTourGeographicalInformation/IndoorTourGeographicalInformationController";
import TurboFrameController from "../../Components/TurboFrame/TurboFrameController";
import UsersCreateOrEditController from "../Users/CreateOrEditController";
import UsersApiTokensController from "../Users/ApiTokensController";
import VideoEditorController from "../../Components/VideoEditor/VideoEditorController";
import VideoPlayerController from "../../Components/VideoPlayer/VideoPlayerController";
import ViewOrEditFormController from "../../Components/ViewOrEditForm/ViewOrEditFormController";
import WorldMapController from "../../Components/WorldMap/WorldMapController";
import DestinationMapController from '../../Components/DestinationMap/DestinationMapController';
import TableController from '../../Components/Table/TableController';
import DestinationToursListController from '../../Components/DestinationToursList/DestinationToursListController';
import DestinationToursListItemController from '../../Components/DestinationToursListItem/DestinationToursListItemController';
import CopyDataToBasePoiController from '../../Components/CopyDataToBasePoi/CopyDataToBasePoiController';
import AddPoiToBaseDestinationController from '../../Components/AddPoiToBaseDestination/AddPoiToBaseDestinationController';
import AddDestinationPoiToTourController from "../../Components/AddDestinationPoiToTour/AddDestinationPoiToTourController";
import CompanyCreateOrEditController from "../../Components/CompanyCreateOrEdit/CompanyCreateOrEditController";
import CompanyBillingAccountController from '../../Features/Companies/Components/CompanyBillingAccount/CompanyBillingAccountController';
import LoginLoginController from "../Login/LoginController";
import HomeIndexController from "../Home/IndexController";
import OnboardingStepController from "../../Components/OnboardingStep/OnboardingStepController";
import BodyController from "../BodyController";
import ButtonWithTooltipController from "../../Components/ButtonWithTooltip/ButtonWithTooltipController";
import HeatmapController from "../../Features/Heatmaps/Components/Heatmap/HeatmapController";
import OnboardingController from "../../Features/Shared/Components/Onboarding/OnboardingController";
import PhonemesPagedListController from "../../Features/Phonemes/Pages/Frames/PhonemesPagedListController";
import DestinationPagedListController from "../../Features/Destinations/Pages/Index/Frames/DestinationPagedList/DestinationPagedListController";
import HintController from "../../Features/Shared/Components/Hint/HintController";
import HintPopupController from "../../Features/Shared/Components/HintPopup/HintPopupController";
import DestinationSearchController from "../../Features/Shared/Components/DestinationSearch/DestinationSearchController";
import UsersPagedListController from "../../Features/Users/Pages/Frames/UsersPagedListController";
import CompaniesPagedListController from "../../Features/Companies/Pages/Frames/CompaniesPagedListController";
import BluetoothBeaconsEditorController from "../../Features/Shared/Components/BluetoothBeaconsEditor/BluetoothBeaconsEditorController";
import CopyAndPasteButtonController from "../../Features/Shared/Components/CopyAndPasteButton/CopyAndPasteButtonController";
import SearchController from "../../Features/Shared/Components/Search/SearchController";
import TouristCardController from "../../Features/Destinations/Components/TouristCard/TouristCardController";
import PoiPagedListController from "../../Features/Destinations/Pages/Detail/Frames/PoiPagedList/PoiPagedListController";
import PagedListFormController from "../../Features/Shared/Components/PagedList/PagedListFormController";

onTurboLoad(() => {
    const applicationContext = getApplicationContext();

    if (applicationContext.environment !== 'development') {
        Sentry.init({
            dsn: 'https://3ffe4da096b5438baeb3cc89aef11de2@o82454.ingest.sentry.io/5959277',
            maxBreadcrumbs: 50,
            debug: false,
            release: applicationContext.appVersion,
            environment: applicationContext.environment,
            integrations: [new Integrations.BrowserTracing()],
            beforeSend(event, hint) {
                if (event.exception) {
                    // Sentry reports unhandled errors as non-fatal by default so they aren't visible in default filters
                    event.level = Sentry.Severity.Fatal;

                    /*
                    Sentry.showReportDialog({
                        eventId: event.event_id,
                        user: {
                            email: applicationContext.userName,
                            name: applicationContext.userName,
                        }
                    });
                    */
                }
                return event;
            },
        });
    }
    Sentry.setUser({
        id: applicationContext.userId,
        username: applicationContext.userName,
    });

    if (applicationContext.environment === 'production' && applicationContext.userId) {
        gtag('set', 'user_properties', {
            'user_id': applicationContext.userId,
            userId: applicationContext.userId,
            userName: applicationContext.userName,
            companyId: applicationContext.companyId,
            companyName: applicationContext.companyName,
        });
    }

    initializeTooltips();
    initializeMinCollectionLengthValidation();
    initializeToggleSectionVisibility();
    initializeInputFileClearing();
    initializeDateTimePickers();
    initializeExpressiveAnnotationsCustomTypeHandling();
    resetSelectizeToCorrectlyMeasureTextWidth();
    initializeHubSpotChat();
    //initializeUserback();

    if (applicationContext.smartlookKey) {
        if (!smartlookClient.default.initialized()) {
            smartlookClient.default.init(applicationContext.smartlookKey);
            smartlookClient.default.properties({
                environment: applicationContext.environment,
                appVersion: applicationContext.appVersion,
            });
        }
        if (applicationContext.userId) {
            smartlookClient.default.identify(applicationContext.userId,
                {
                    name: applicationContext.userName || '',
                });
        }
    }
});

initializeTranslations();
initializeStorage(localStorage);
fixChromeWrappingTextInSpanWhenDeletingLineBreak();
initializeSummerNoteIgnoredInValidation();
initializePageScrollPositionAndActiveTabsSaver();

// @ts-ignore
Dropzone.autoDiscover = false; // prevent Uncaught Error: Dropzone already attached.

const application = Application.start();
application.register("audio-player", AudioPlayerController);
application.register("audio-editor", AudioEditorController);
application.register("collapsible-section", CollapsibleSectionController);
application.register("companies--create-or-edit", CompaniesCreateOrEditController);
application.register("companies--register", RegisterCompanyController);
application.register(StimulusControllers.destinationMap, DestinationMapController);
application.register(StimulusControllers.destinationsAddNewDestination, DestinationsAddNewDestinationController);
application.register("destinations--cloning", DestinationsCloningController);
application.register("destinations--create-or-edit", DestinationsCreateOrEditController);
application.register(StimulusControllers.destinationsDetailBasicInformation, DestinationsDetailBasicInformationController);
application.register(StimulusControllers.destinationsDetail, DestinationsDetailController);
application.register("destinations--index", DestinationsIndexController);
application.register("destinations--add-new-destination-map", DestinationsAddNewDestinationMapController);
application.register("destinations--cloned-destinations-list", DestinationsClonedDestinationsListController);
application.register("destinations--progress-bar-step", DestinationsProgressBarStepController);
application.register("destinations--magically-open-cloned-destination", DestinationsMagicallyOpenClonedDestinationController);
application.register("destinations--validation-check", DestinationsValidationCheckController);
application.register("image-editor", ImageEditorController);
application.register("map", MapController);
application.register(StimulusControllers.tourMap, TourMapController);
application.register("phonemes--create-or-edit", PhonemesCreateOrEditController);
application.register("phonemes--delete", PhonemesDeleteController);
application.register("pois--create", PoisCreateController);
application.register("pois--create-or-edit", PoisCreateOrEditController);
application.register("pois--detail-old", PoisDetailOldController);
application.register(StimulusControllers.poisDetail, PoisDetailController);
application.register(StimulusControllers.createNewPoiFromMap, PoisCreateNewPoiFromMapController);
application.register(StimulusControllers.poisDetailAdditionalInformation, PoisDetailAdditionalInformationController);
application.register(StimulusControllers.translation, TranslationController);
application.register(StimulusControllers.poisDetailBasicInformation, PoisDetailBasicInformationController);
application.register(StimulusControllers.poisDetailAiGeneratedContent, PoisDetailAiGeneratedContentController);
application.register("pois--detail-common-information", PoisDetailCommonInformationController);
application.register("pois--detail-geographical-information", PoisDetailGeographicalInformationController);
application.register("section-item", SectionItemController);
application.register("tours--create", ToursCreateController);
application.register("tours--edit", ToursEditController);
application.register(StimulusControllers.toursDetailAdditionalInformation, ToursDetailAdditionalInformationController);
application.register(StimulusControllers.toursDetailBasicInformation, ToursDetailBasicInformationController);
application.register(StimulusControllers.toursDetail, ToursDetailController);
application.register(StimulusControllers.indoorTourGeographicalInformation, ToursDetailIndoorTourGeographicalInformationController);
application.register("turbo-frame", TurboFrameController);
application.register("users--create-or-edit", UsersCreateOrEditController);
application.register("users--api-tokens", UsersApiTokensController);
application.register("video-editor", VideoEditorController);
application.register("video-player", VideoPlayerController);
application.register("view-or-edit-form", ViewOrEditFormController);
application.register("world-map", WorldMapController);
application.register("table", TableController);
application.register("destination-tours-list", DestinationToursListController);
application.register("destination-tour", DestinationToursListItemController);
application.register("copy-data-to-base-poi", CopyDataToBasePoiController);
application.register("add-poi-to-base-destination", AddPoiToBaseDestinationController);
application.register(StimulusControllers.addDestinationPoiToTour, AddDestinationPoiToTourController);
application.register("company-create-or-edit", CompanyCreateOrEditController);
application.register("company-billing-account", CompanyBillingAccountController);
application.register("login--login", LoginLoginController);
application.register("home--index", HomeIndexController);
application.register("onboarding-step", OnboardingStepController);
application.register("body", BodyController);
application.register("button-with-tooltip", ButtonWithTooltipController);
application.register("heatmap", HeatmapController);
application.register(StimulusControllers.onboarding, OnboardingController);
application.register(StimulusControllers.phonemesPagedList, PhonemesPagedListController);
application.register(StimulusControllers.destinationPagedList, DestinationPagedListController);
application.register(StimulusControllers.hint, HintController);
application.register(StimulusControllers.hintPopup, HintPopupController);
application.register(StimulusControllers.destinationSearch, DestinationSearchController);
application.register(StimulusControllers.usersPagedList, UsersPagedListController);
application.register(StimulusControllers.companiesPagedList, CompaniesPagedListController);
application.register(StimulusControllers.bluetoothBeaconsEditor, BluetoothBeaconsEditorController);
application.register("copy-and-paste-button", CopyAndPasteButtonController);
application.register(StimulusControllers.search, SearchController);
application.register(StimulusControllers.touristCard, TouristCardController);
application.register(StimulusControllers.poiPagedList, PoiPagedListController);
application.register(StimulusControllers.pagedListForm, PagedListFormController);

application.handleError = (error, message, detail) => {
    console.error(error, message, detail);

    // @ts-ignore
    const identifier = detail?.identifier;
    // @ts-ignore
    const elementId = detail?.element?.id;

    Sentry.captureException(error,
        {
            // Sentry reports unhandled errors as non-fatal by default so they aren't visible in default filters
            level: Sentry.Severity.Fatal,
            contexts: {
                turbo: {
                    identifier,
                    elementId,
                }
            }
        });
}

logMainJsScriptVersion();

function logMainJsScriptVersion() {
    const mainJsElement = document.getElementById("main_js");
    const version = mainJsElement
        ? mainJsElement.getAttribute("src")!.replace("/js/main.js?v=", "")
        : "";
    console.log(`Turbo reloaded, main.js version: ${version}`);
}
